import styled from 'styled-components'
import Text from './Text'

const defaultValues = {
  fontSize: ['18px', '20px'],
  fontFamily: 'Proxima',
  letterSpacing: '0.9px',
  lineHeight: '24px',
  fontWeight: 'heavy',
  textTransform: 'uppercase'
}

const CTA = styled(Text)``

CTA.defaultProps = {
  ...defaultValues
}

export {
  CTA,
  defaultValues
}
